import { render } from "./Widget11.vue?vue&type=template&id=390e978e"
import script from "./Widget11.vue?vue&type=script&lang=ts"
export * from "./Widget11.vue?vue&type=script&lang=ts"
script.render = render

export default script